import { Component, ViewEncapsulation, input, model } from '@angular/core';

@Component({
  selector: 'app-unit-toggle',
  templateUrl: './unit-toggle.component.html',
  styleUrls: ['./unit-toggle.component.scss'],
  encapsulation: ViewEncapsulation.ShadowDom,
  standalone: true
})
export class UnitToggleComponent {
  /** Available unit options, e.g. ['mm', 'in'] */
  options = input<string[]>(['mm', 'in']);

  /** Currently selected unit */
  value = model<string>('mm');

  /** Whether the toggle is disabled */
  disabled = input(false);

  select(option: string): void {
    if (!this.disabled() && option !== this.value()) {
      this.value.set(option);
    }
  }
}
